var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDotsH = function SvgDotsH(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0M4 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0m12 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
  })));
};
export { SvgDotsH as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiI+PHBhdGggZD0iTTEwIDhhMiAyIDAgMSAxLTQgMCAyIDIgMCAwIDEgNCAwWk00IDhhMiAyIDAgMSAxLTQgMCAyIDIgMCAwIDEgNCAwWm0xMiAwYTIgMiAwIDEgMS00IDAgMiAyIDAgMCAxIDQgMFoiIGZpbGw9IiNmZmYiLz48L3N2Zz4K";